import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { connect } from 'react-redux';
var defaultPolltypeHost = 'https://www.polltype.com';

var PolltypeBase = /*#__PURE__*/function (_React$Component) {
  _inherits(PolltypeBase, _React$Component);

  var _super = /*#__PURE__*/_createSuper(PolltypeBase);

  function PolltypeBase() {
    _classCallCheck(this, PolltypeBase);

    return _super.apply(this, arguments);
  }

  _createClass(PolltypeBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadPolltypeJS();
    }
  }, {
    key: "loadPolltypeJS",
    value: function loadPolltypeJS() {
      var source = this.props.polltypeHost.replace(/^https:|^http:/i, '') + '/embed.js';

      if (!global._polltypeAdded) {
        global._polltypeAdded = true;
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = source;
        document.body.appendChild(script);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-polltype-embed-id": this.props.id
      });
    }
  }]);

  return PolltypeBase;
}(React.Component);

function mapStateToProps(state) {
  return {
    polltypeHost: state.qt.config["polltype-host"] || defaultPolltypeHost
  };
}

var Polltype = /*#__PURE__*/connect(mapStateToProps, {})(PolltypeBase);
export default Polltype;